import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/SysUser/Department/';

const state = {};

const mutations = {};

const actions = {

  ShowTreeInWebsite({commit}, view) {
    return request.PromiseCall(basePath, 'ShowTreeInWebsite', view);
  },
  CheckInClient({commit}, view) {
    return request.PromiseCall(basePath, 'CheckInClient', view);
  },
  Check({commit}, view) {
    return request.PromiseCall(basePath, 'Check', view);
  },


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/SysUser/Department/index.js